import { jsx } from '@emotion/react';
import { Spinner } from '../../display/Spinner/Spinner.es.js';
import { Button } from '../Button/Button.es.js';

const LoadMoreBar = (props) => {
  const { children, isLoading, onClick, size } = props;
  const spinner = jsx(
    "span",
    { css: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--zds-space-12)"
    }, "data-zds": true },
    jsx(Spinner, { color: "dark", "aria-label": "Loading icon" }),
    "Loading"
  );
  return jsx(Button, { color: "secondary", disabled: isLoading, isFullWidth: true, onClick, size }, isLoading ? spinner : children);
};

export { LoadMoreBar };
//# sourceMappingURL=LoadMoreBar.es.js.map
